var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigurewalk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 16.9336 27.2461",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 27.2461,
    opacity: 0,
    width: 16.9336,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07421 26.332L5.76561 21.9375C6.12889 21.5156 6.17577 21.3984 6.32811 20.9531L6.62108 20.0508L4.64061 17.5664L4.01952 20.4141L0.374988 24.7383C-0.808606 26.1211 1.10155 27.4805 2.07421 26.332ZM11.0742 25.9688C11.8242 27.5156 14.0976 26.5664 13.2773 24.9023L10.7695 19.8164C10.582 19.4297 10.3008 19.0195 10.0781 18.6914L8.47264 16.418L8.58983 16.0898C9.03514 14.8242 9.17577 14.0508 9.26952 12.7852L9.51561 9.23438C9.64452 7.54688 8.64843 6.25781 6.91405 6.25781C5.61327 6.25781 4.73436 6.91406 3.53905 8.08594L1.66405 9.9375C1.04296 10.5469 0.843738 11.0391 0.785144 11.8359L0.562488 14.7422C0.503894 15.4688 0.91405 15.9961 1.59374 16.0195C2.27343 16.0664 2.68358 15.668 2.76561 14.8828L3.03514 11.6953L3.93749 10.875C4.26561 10.582 4.69921 10.7812 4.67577 11.1094L4.46483 13.8164C4.35936 15.1758 4.68749 15.8203 5.62499 16.9922L8.10936 20.1211C8.36718 20.4375 8.39061 20.5664 8.49608 20.7539ZM15.3516 11.0742L12.5039 11.0742L10.6523 9.01172L10.4648 12L11.2266 12.75C11.625 13.1602 11.9766 13.2773 12.7031 13.2773L15.3516 13.2773C16.0898 13.2773 16.582 12.8555 16.582 12.1641C16.582 11.5078 16.0781 11.0742 15.3516 11.0742ZM8.28514 5.15625C9.71483 5.15625 10.8633 4.00781 10.8633 2.57812C10.8633 1.14844 9.71483 0 8.28514 0C6.85546 0 5.70702 1.14844 5.70702 2.57812C5.70702 4.00781 6.85546 5.15625 8.28514 5.15625Z",
    fill: "currentColor",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigurewalk);
export default __webpack_public_path__ + "static/media/figure.walk.b62989e67fb9329d5fb16731098c810f.svg";
export { ForwardRef as ReactComponent };